/**
 * The realtime token mint (createRealtimeToken). The result alias keeps every caller's `data.getRealtimeToken`
 * read unchanged; the old getRealtimeToken root is gone (FU-D2e).
 */
export const CreateRealtimeToken = gql`
  mutation CreateRealtimeToken($input: CreateRealtimeTokenInput!) {
    getRealtimeToken: createRealtimeToken(input: $input) {
      key
      channel
      topics
    }
  }
`;
